import React from 'react'

const Api = () => {


    const Loggin = 'https://travelflight.pdtcomunicaciones.com/api/pollitan'
    const cityUrl = 'https://travelflight.pdtcomunicaciones.com/api/pollitan/city'
    const originUrl = 'https://travelflight.pdtcomunicaciones.com/api/pollitan/origin'
    const destinyUrl = 'https://travelflight.pdtcomunicaciones.com/api/pollitan/destination'
    const servicesUrl = 'https://travelflight.pdtcomunicaciones.com/api/pollitan/product'

  return {
    Loggin,
    cityUrl,
    originUrl,
    destinyUrl,
    servicesUrl
  }
}

export default Api